<template>
  <layout title="Generate Letters (MR)"></layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";

export default {
  components: { Layout },
};
</script>

<style></style>
